import BrutkastenBeteiligungen from 'components/profiles/BrutkastenBeteiligungen/BrutkastenBeteiligungen';
import type { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import { Referenz, ReferenzType } from 'types';
import { UnternehmenFreeDto } from 'types/unternehmen';
import { getBrutkastenNetzwerkServerSideProps } from 'utils/profileStaticProps';


interface UnternehmensProfilPageProps
{
  unternehmen: UnternehmenFreeDto;
  isoDate: string | null;
}

const NetzwerkPage: NextPage<UnternehmensProfilPageProps> = ({ unternehmen, isoDate }) =>
{

  const origin: Referenz = {
    id: unternehmen.fbNr,
    name: unternehmen.name,
    type: ReferenzType.Unternehmen,
    isIndexed: false,
  };

  const sortedDates = Object.keys(unternehmen.netzwerk).sort((a, b) => b.localeCompare(a));
  const queryDate = isoDate ? sortedDates.find(d => d.localeCompare(isoDate) <= 0) : undefined;
  const selectedDate = queryDate || sortedDates[0];

  return (
      <BrutkastenBeteiligungen
        origin={origin}
        netzwerk={unternehmen.netzwerk[selectedDate]}
        date={queryDate ? new Date(queryDate) : null}
      />
  );
};

export default NetzwerkPage;

export const getServerSideProps: GetServerSideProps = async (ctx) =>
{
  const props = await getBrutkastenNetzwerkServerSideProps(ctx);
  return props;
};
